module.exports = __webpack_public_path__ + "img/img7.0a63edaa.png";